<template lang="pug">
  .d-flex.align-center.py-1()
    .text--gray.hud3() {{this.label}}
    .ml-3.hud2.px-2.py-1.font-weight-bold() {{this.value}}


</template>

<script>
export default {
  props:{
    label:{
      type:String,
      default: "Label"
    },
    value: {
      type: String,
      default: "60 Kph"
    }


  }
}
</script>

<style scoped lang="stylus">
.hud2{
  background: #00000077;
  border-radius: 7px;
  color white;
  width: 120px;
  text-align: center;
}
.hud3{
  width: 100px;
  text-align right;
}
</style>